module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-04@2x.8ddf477e.jpg";